import React, { ReactNode } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { deDE } from "@mui/x-date-pickers/locales";
import { AuthProvider } from "@providers/AuthContext";
import { LoginOrConfirmation } from "@features/login/LoginOrConfirmation";
import { ArivaHeader } from "@components/ArivaHeader";
import { useI18NextLocale } from "@hooks";
import { AppWrapper } from "./AppWrapper";
import { AppRouter } from "./routes/AppRouter";
import "@hooks";
import "./style.css";

const germanLocale =
  deDE.components.MuiLocalizationProvider.defaultProps.localeText;

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const dateLocale = useI18NextLocale();
  return (
    <AppWrapper>
      <CssBaseline />
      <ArivaHeader />
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={dateLocale}
        localeText={germanLocale}
      >
        {children}
      </LocalizationProvider>
    </AppWrapper>
  );
};

export const App = () => {
  return (
    <AppProvider>
      <AuthProvider loginComponent={LoginOrConfirmation}>
        <AppRouter />
      </AuthProvider>
    </AppProvider>
  );
};

export default App;
